import { GeoPoint, LocationType } from '../SearchLocation.types'

/**
 * Parses a PostGIS POINT string format into a GeoPoint object
 * @param pointString - String in format "POINT(longitude latitude)"
 * @returns GeoPoint object with lat and lon properties, or null if invalid
 */
export const parsePointString = (pointString: string): GeoPoint | null => {
  if (!pointString || typeof pointString !== 'string') {
    return null
  }

  // Match POINT(lon lat) format
  const match = pointString.match(/POINT\((-?\d+\.?\d*)\s+(-?\d+\.?\d*)\)/)

  if (!match) {
    return null
  }

  const lon = parseFloat(match[1])
  const lat = parseFloat(match[2])

  if (isNaN(lon) || isNaN(lat)) {
    return null
  }

  return { lat, lon }
}

/**
 * Formats a GeoPoint object into a PostGIS POINT string
 * @param geoPoint - GeoPoint object with lat and lon properties
 * @returns String in format "POINT(longitude latitude)"
 */
export const formatPointString = (geoPoint: GeoPoint): string => {
  return `POINT(${geoPoint.lon} ${geoPoint.lat})`
}

/**
 * Gets the appropriate zoom level based on location type
 * @param locationType - The type of location
 * @returns Zoom level (13 for municipality, 17 for others)
 */
export const getZoomLevelForLocationType = (
  locationType: LocationType
): number => {
  return locationType === 'municipality' ? 13 : 17
}
